import { plainToInstance } from 'class-transformer';
import { AbstractNetworkService } from 'core/data/remote/AbstractNetworkService';
import { NetWorkService } from 'core/data/remote/NetworkService';
import { ResponseResult } from 'core/models/ResponseResult';
import { IroningModel } from 'features/ironing/data/models/IroningModel';
import { AbstractIroningRemoteDataSource } from 'features/ironing/data/remote/Abstract_ironing_remote_data_source';
import { SewingModel } from 'features/sewing/data/models/SewingModel';
import { IroningPackageModel } from 'features/ironing/data/models/IroningPackageModel';
export class IroningRemoteDataSource implements AbstractIroningRemoteDataSource {
  netowkService: AbstractNetworkService = new NetWorkService();
  async getWashingAndIroningTshisrtPackageData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/washing_and_ironing_tshirt_packages_get');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return new ResponseResult({
        code: '0',
        timeStamp: new Date().toISOString(),
        success: false,
        message: 'Unknown Error - An undefined error occured',
        data: null,
      });
    }
  }

  async getWashingAndIroningByPieceData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/washing_and_ironing_by_piece_get');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return new ResponseResult({
        code: '0',
        timeStamp: new Date().toISOString(),
        success: false,
        message: 'Unknown Error - An undefined error occured',
        data: null,
      });
    }
  }

  async getAssortedClothesData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/iron_assorted_cloths_get');
      response.data = this.convertFromJsonToIroningPackageModel(response.data);
      return response;
    } catch (error) {
      return new ResponseResult({
        code: '0',
        timeStamp: new Date().toISOString(),
        success: false,
        message: 'Unknown Error - An undefined error occured',
        data: null,
      });
    }
  }

  async getAssortedClothesWithoutShirtsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/assorted_clothes_without_shirts_get');
      response.data = this.convertFromJsonToIroningPackageModel(response.data);
      return response;
    } catch (error) {
      return new ResponseResult({
        code: '0',
        timeStamp: new Date().toISOString(),
        success: false,
        message: 'Unknown Error - An undefined error occured',
        data: null,
      });
    }
  }

  async getIronByPieceData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/iron_by_piece_get');
      response.data = this.convertFromJsonToSewingModel(response.data);
      return response;
    } catch (error) {
      return new ResponseResult({
        code: '0',
        timeStamp: new Date().toISOString(),
        success: false,
        message: 'Unknown Error - An undefined error occured',
        data: null,
      });
    }
  }

  convertFromJsonToSewingModel(data: any): SewingModel[] {
    return (data as []).flatMap((e) => plainToInstance(SewingModel, e));
  }

  convertFromJsonToTableModel(data: any): IroningModel[] {
    return data.map((item: any) => new IroningModel(item.name, item.minPrice ?? item.price, item.maxPrice))
  }

  convertFromJsonToIroningPackageModel(data: any): IroningPackageModel[] {
    return (data as []).flatMap((e) => plainToInstance(IroningPackageModel, e));
  }
}
